import React, { useState, useEffect } from 'react';
import { createClient } from '@supabase/supabase-js';
import Cookies from 'js-cookie';
import { useDropzone } from 'react-dropzone';
import { Card, CardContent, Typography, Grid, IconButton, CircularProgress } from '@mui/material';
import AudiotrackIcon from '@mui/icons-material/Audiotrack';
import DescriptionIcon from '@mui/icons-material/Description';
import DeleteIcon from '@mui/icons-material/Delete';
import { useNavigate } from 'react-router-dom';
import Navbar from './Navbar';

const supabaseUrl = 'https://ahimpdkjedsuidziiths.supabase.co';
const supabaseKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImFoaW1wZGtqZWRzdWlkemlpdGhzIiwicm9sZSI6ImFub24iLCJpYXQiOjE3MTI4NTA1NDIsImV4cCI6MjAyODQyNjU0Mn0.9rPs2gIzMYYqHXHQHU298xc58r6lpcCE_a7ooG5vRQk';
const supabase = createClient(supabaseUrl, supabaseKey);

function Voice_clips() {
    const userId = Cookies.get('userId');
    const memorialId = Cookies.get('memorialId');
    const [uploadedFiles, setUploadedFiles] = useState([]);
    const [loading, setLoading] = useState(false); // Loading state for async operations
    const navigate = useNavigate();

    useEffect(() => {
        if (userId && memorialId) {
            updateFilesInDirectory();
        }
    }, [userId, memorialId]);

    const onDrop = React.useCallback((acceptedFiles) => {
        acceptedFiles.forEach(file => handleFileUpload(file));
    }, [userId, memorialId]);

    const { getRootProps, getInputProps, isDragActive } = useDropzone({
        onDrop,
        accept: 'audio/*',
        maxSize: 50242880, // 50MB
    });

    const handleFileUpload = async (file) => {
        if (!userId || !memorialId) {
            console.error('Missing userId or memorialId cookies');
            return;
        }
        setLoading(true); // Set loading state

        const bucketName = 'memorial_voice_clips';

        const { data, error } = await supabase.storage
            .from(bucketName)
            .upload(`public/${userId}/${memorialId}/${file.name}`, file, { upsert: true });

        setLoading(false); // Clear loading state

        if (error) {
            console.error('Error uploading file:', error.message);
            return;
        }

        console.log('File uploaded successfully:', data.Key);
        await updateFilesInDirectory();
    };

    const handleFileDelete = async (fileName) => {
        setLoading(true); // Set loading state

        const bucketName = 'memorial_voice_clips';

        const { data, error } = await supabase.storage
            .from(bucketName)
            .remove([`public/${userId}/${memorialId}/${fileName}`]);

        setLoading(false); // Clear loading state

        if (error) {
            console.error('Error deleting file:', error.message);
            return;
        }

        console.log('File deleted successfully:', data);
        await updateFilesInDirectory();
    };

    const updateFilesInDirectory = async () => {
        const bucketName = 'memorial_voice_clips';

        const { data: fileList, error: listError } = await supabase.storage
            .from(bucketName)
            .list(`public/${userId}/${memorialId}`);

        if (listError) {
            console.error('Error listing files:', listError.message);
            return;
        }

        const voiceClipsObject = fileList
            .filter(file => ['mp3', 'wav'].includes(file.name.split('.').pop()))
            .map(file => ({
                name: file.name,
                url: `${supabaseUrl}/storage/v1/object/public/${bucketName}/public/${userId}/${memorialId}/${file.name}`,
                type: file.name.split('.').pop()
            }));

        setUploadedFiles(voiceClipsObject);

        try {
            const { data, error } = await supabase
                .from('memorials')
                .update({ voice_clips: voiceClipsObject })
                .eq('owner_id', userId)
                .eq('memorial_Id', memorialId);

            if (error) {
                throw error;
            }

            console.log('Voice Clips URLs updated successfully');
        } catch (error) {
            console.error('Error updating voice clips URLs:', error.message);
        }
    };

    return (
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
            <div style={{ width: '85%', height: '85%', backgroundColor: 'rgba(255, 255, 255, 0.8)', padding: '20px', display: 'flex', flexDirection: 'column', alignItems: 'center', borderRadius: '10px' }}>
                <h2>Upload Voice Clips</h2>
                {loading && <CircularProgress />} {/* Show loading indicator */}
                <br />
                <div {...getRootProps()} style={{ border: '2px dashed black', padding: '20px', textAlign: 'center' }}>
                    <input {...getInputProps()} />
                    {isDragActive ? <p>Drop the files here ...</p> : <p>Drag 'n' drop some files here, or click to select files</p>}
                </div>
                <br />
                <h3>Uploaded Files:</h3>
                <br />
                <Grid container spacing={2} justifyContent="center">
                    {uploadedFiles.map((file, index) => (
                        <Grid item xs={12} sm={6} key={index}>
                            <Card style={{
                                width: '100%',
                                paddingTop: '100%', // This ensures the card is square
                                position: 'relative', // This is needed for absolute positioning
                                backgroundColor: ['mp3', 'wav'].includes(file.type) ? '#edc966' : '#fff'
                            }}>
                                <CardContent style={{ position: 'absolute', top: 0, right: 0, bottom: 0, left: 0 }}>
                                    <IconButton onClick={() => handleFileDelete(file.name)} style={{ position: 'absolute', right: 0, top: 0 }}>
                                        <DeleteIcon />
                                    </IconButton>
                                    {['mp3', 'wav'].includes(file.type) && <AudiotrackIcon />}
                                    {!['mp3', 'wav'].includes(file.type) && <DescriptionIcon />}
                                    <Typography variant="body2" style={{ fontSize: '0.75rem' }}>{file.name}</Typography>
                                </CardContent>
                            </Card>
                        </Grid>
                    ))}
                </Grid>
            </div>
        </div>
    );
}

export default Voice_clips;
